module.exports = __webpack_public_path__ + "media/assets/icons/chain-broken-29300884b2f08bd546005b1ef2b185c7.svg";